/* eslint require-jsdoc: 'error', valid-jsdoc: ["error", { "requireReturn": false }] */

import DragBase from '../_internal/dragbase';
import DragColumnDataset from '../../dataset/dragcolumn';
import DragColumnMultiseriesGroup from '../../dataset/groups/dragcolumn-multiseries';
import LimitUpdaterFactory from '../../factories/limit-updater';
import dragtrackerFactory from '../../factories/drag-tracker';

/**
 * API class of dragcolumn inheriting from column class
 */
class DragColumn extends DragBase {
  /**
   * constructor to register limit updater
   */
  constructor () {
    super();
    this.registerFactory('limitUpdater', LimitUpdaterFactory, ['axis']);
    this.registerFactory('dragTracker', dragtrackerFactory, ['canvas']);
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'DragColumn2D';
  }
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'DragColumn2D';
  }

  /**
   * This method return the dataset-group definations for this charts
   * @return {Object}       Multiseries Dragcolumn group definition
   */
  getDSGroupdef () {
    return DragColumnMultiseriesGroup;
  }

  /**
   * Function to parse chart specific configurations.
   */
  __setDefaultConfig () {
    super.__setDefaultConfig();
    this.config.isDrag = true;
  }
  /**
   * Function to return the dataset liked with the current API
   * @return {Object} The DragColumnDataset class
   */
  getDSdef () {
    return DragColumnDataset;
  }
}
export default DragColumn;
